import { Injectable, Provider } from '@angular/core';

export interface User {
  email: string;
  name: string;
  role: string;
  id: number;
  idMixpanel: string;
  isPj: boolean;
  emailIndicador: string;

  codigoCompartilhamento: string;
  oferta: string;
  canal: string;
  saldo: string;
  valorConvidado: string;
}

@Injectable()
export class AuthService {
  getCurrentUser(): Partial<User> {
    return null;
  }

  async logout(_): Promise<any> {
    return null;
  }
}

export function AuthServiceFactory(i: any) {
  return i.get('Auth');
}

export const AuthServiceProvider: Provider = {
  provide: AuthService,
  useFactory: AuthServiceFactory,
  deps: ['$injector'],
};
